import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TextButton = styled(Button)`
  text-transform: none;
`;
